import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Logo from '@/components/logo' //门票预约
import Information from '@/components/information' //填写信息
import Personal from '@/components/personal' //预约时间
import FillInformation from '@/components/fill_information' //预约列表
import Success from '@/components/success' //预约成功
import AppointmentDetails from '@/components/appointment_details' //订单详情
import Land from '@/components/land' //团队登录
import PersonalLand from '@/components/personalLand' //个人登录
import PersonalRegistration from '@/components/personalRegistration' //个人注册
import GroupRegistration from '@/components/groupRegistration' //团队注册
import TeamReservation from '@/components/teamReservation' //团队预约
import ChangePassword from '@/components/changePassword' //修改密码
import ForgetPassword from '@/components/forgetPassword' //忘记密码
import PersonalCenter from '@/components/personalCenter' //个人中心
import TicketReservation from '@/components/ticketReservation' //订单列表
import ReadingFile from '@/components/readingFile' //观后感
import CancelReservation from '@/components/cancelReservation' //取消预约
import ActivityRegistration from '@/components/activityRegistration' //活动报名
import TourGuide from '@/components/tourGuide' //参观指南
import CenterLand from '@/components/CenterLand' //登录
import TeamCenter from '@/components/teamCenter' //团队中心
import Loading from '@/components/loading' //检测登录
import DetailsActivities from '@/components/detailsActivities' //活动预约
import Article from '@/components/article' //新闻资讯
import Articleitem from '@/components/articleitem' //资讯详情
import Collection from '@/components/collection' //藏品列表
import Collectionitem from '@/components/Collectionitem' //藏品详情
import Details from '@/components/details' //订单详情
import Activities from '@/components/activities' //活动预约
import Seek from '@/components/Seek' //寻人寻物
import SeekDetails from '@/components/SeekDetails' //寻人寻物详情
import PublishCollect from '@/components/PublishCollect' //发布
import Lease from '@/components/Lease' //租赁
import LeaseInformation from '@/components/LeaseInformation' //租赁
import ToMy from '@/components/ToMy' //我的门票
import ToCenter from '@/components/ToCenter' //个人中心
import Solicitation from '@/components/Solicitation' //藏品征集
import SearchForPeople from '@/components/SearchForPeople' //我的寻人
import LostArticle from '@/components/LostArticle' //我的失物
import MyLease from '@/components/MyLease' //我的租赁
import Explain from '@/components/Explain' //预约讲解
import ExplainDetails from '@/components/ExplainDetails' //预约讲解详情
import Complaint from '@/components/Complaint' //投诉建议
import Survey from '@/components/Survey' //纪念馆概况
import MyComplaint from '@/components/MyComplaint' //我的投诉
import MyComplaintDetails from '@/components/MyComplaintDetails' //我的投诉
import MapGuide from '@/components/mapGuide' //地图导览
import Evaluate from '@/components/evaluate' //讲解评价
import EvaluateDetails from '@/components/evaluateDetails' //讲解评价详情
import Travel from '@/components/travel' //讲解评价详情

Vue.use(Router)

export default new Router({
	routes: [{
			path: '/',
			name: 'Logo',
			component: Logo,
			meta: {
				title: '门票预约'
			}
		},
		{
			path: '/Information',
			name: 'Information',
			component: Information,
			meta: {
				title: '填写信息'
			}
		},
		{
			path: '/Collectionitem',
			name: 'Collectionitem',
			component: Collectionitem,
			meta: {
				title: '藏品详情'
			}
		},

		{
			path: '/Articleitem',
			name: 'Articleitem',
			component: Articleitem,
			meta: {
				title: '资讯详情'
			}
		},
		{
			path: '/Collection',
			name: 'Collection',
			component: Collection,
			meta: {
				title: '导览服务'
			}
		},
		{
			path: '/Article',
			name: 'Article',
			component: Article,
			meta: {
				title: '最新资讯'
			}
		},
		{
			path: '/Personal',
			name: 'Personal',
			component: Personal,
			meta: {
				title: '门票预约'
			}
		},
		{
			path: '/FillInformation',
			name: 'FillInformation',
			component: FillInformation,
			meta: {
				title: '预约'
			}
		},
		{
			path: '/Success',
			name: 'Success',
			component: Success,
			meta: {
				title: '预约成功'
			}
		},
		{
			path: '/AppointmentDetails',
			name: 'AppointmentDetails',
			component: AppointmentDetails,
			meta: {
				title: '订单详情'
			}
		},
		{
			path: '/Land',
			name: 'Land',
			component: Land,
			meta: {
				title: '团队登录'
			}
		},
		{
			path: '/Travel',
			name: 'Travel',
			component: Travel,
			meta: {
				title: '旅行社登录'
			}
		},
		{
			path: '/PersonalRegistration',
			name: 'PersonalRegistration',
			component: PersonalRegistration,
			meta: {
				title: '个人注册'
			}
		},
		{
			path: '/GroupRegistration',
			name: 'GroupRegistration',
			component: GroupRegistration,
			meta: {
				title: '团队注册'
			}
		},
		{
			path: '/TeamReservation',
			name: 'TeamReservation',
			component: TeamReservation,
			meta: {
				title: '团队预约'
			}
		},
		{
			path: '/ChangePassword',
			name: 'ChangePassword',
			component: ChangePassword,
			meta: {
				title: '修改密码'
			}
		},
		{
			path: '/PersonalCenter',
			name: 'PersonalCenter',
			component: PersonalCenter,
			meta: {
				title: '个人中心'
			}
		},
		{
			path: '/TicketReservation',
			name: 'TicketReservation',
			component: TicketReservation,
			meta: {
				title: '订单列表'
			}
		},
		{
			path: '/ReadingFile',
			name: 'ReadingFile',
			component: ReadingFile,
			meta: {
				title: '观后感'
			}
		},
		{
			path: '/CancelReservation',
			name: 'CancelReservation',
			component: CancelReservation,
			meta: {
				title: '取消预约'
			}
		},
		{
			path: '/ActivityRegistration',
			name: 'ActivityRegistration',
			component: ActivityRegistration,
			meta: {
				title: '活动报名'
			}
		},
		{
			path: '/TourGuide',
			name: 'TourGuide',
			component: TourGuide,
			meta: {
				title: '参观指南'
			}
		},
		{
			path: '/CenterLand',
			name: 'CenterLand',
			component: CenterLand,
			meta: {
				title: '登录'
			}
		},
		{
			path: '/TeamCenter',
			name: 'TeamCenter',
			component: TeamCenter,
			meta: {
				title: '团队中心'
			}
		},
		{
			path: '/Loading',
			name: 'Loading',
			component: Loading
		},
		{
			path: '/DetailsActivities',
			name: 'DetailsActivities',
			component: DetailsActivities,
			meta: {
				title: '活动预约'
			}
		},
		{
			path: '/Details',
			name: 'Details',
			component: Details,
			meta: {
				title: '订单详情'
			}
		},
		{
			path: '/PersonalLand',
			name: 'PersonalLand',
			component: PersonalLand,
			meta: {
				title: '个人登录'
			}
		},
		{
			path: '/Activities',
			name: 'Activities',
			component: Activities,
			meta: {
				title: '活动预约'
			}
		},
		{
			path: '/ForgetPassword',
			name: 'ForgetPassword',
			component: ForgetPassword,
			meta: {
				title: '忘记密码'
			}
		},
		{
			path: '/Seek',
			name: 'Seek',
			component: Seek,
			meta: {
				title: '寻人寻物'
			}
		},
		{
			path: '/SeekDetails',
			name: 'SeekDetails',
			component: SeekDetails,
			meta: {
				title: '寻人寻物'
			}
		},
		{
			path: '/PublishCollect',
			name: 'PublishCollect',
			component: PublishCollect,
			meta: {
				title: '发布招领'
			}
		},
		{
			path: '/ToMy',
			name: 'ToMy',
			component: ToMy
		},
		{
			path: '/ToCenter',
			name: 'ToCenter',
			component: ToCenter
		},
		{
			path: '/Solicitation',
			name: 'Solicitation',
			component: Solicitation,
			meta: {
				title: '藏品征集'
			}
		},
		{
			path: '/Lease',
			name: 'Lease',
			component: Lease,
			meta: {
				title: '设备租赁'
			}
		},
		{
			path: '/LeaseInformation',
			name: 'LeaseInformation',
			component: LeaseInformation,
			meta: {
				title: '设备租赁'
			}
		},
		{
			path: '/SearchForPeople',
			name: 'SearchForPeople',
			component: SearchForPeople,
			meta: {
				title: '我的寻人'
			}
		},
		{
			path: '/LostArticle',
			name: 'LostArticle',
			component: LostArticle,
			meta: {
				title: '我的失物'
			}
		},
		{
			path: '/MyLease',
			name: 'MyLease',
			component: MyLease,
			meta: {
				title: '我的租赁'
			}
		},
		{
			path: '/Explain',
			name: 'Explain',
			component: Explain,
			meta: {
				title: '预约讲解'
			}
		},
		{
			path: '/ExplainDetails',
			name: 'ExplainDetails',
			component: ExplainDetails,
			meta: {
				title: '预约讲解'
			}
		},
		{
			path: '/Complaint',
			name: 'Complaint',
			component: Complaint,
			meta: {
				title: '投诉建议'
			}
		},
		{
			path: '/Survey',
			name: 'Survey',
			component: Survey,
			meta: {
				title: '纪念馆概况'
			}
		},
		{
			path: '/MyComplaint',
			name: 'MyComplaint',
			component: MyComplaint,
			meta: {
				title: '我的投诉'
			}
		},
		{
			path: '/MyComplaintDetails',
			name: 'MyComplaintDetails',
			component: MyComplaintDetails,
			meta: {
				title: '我的投诉'
			}
		},
		{
			path: '/MapGuide',
			name: 'MapGuide',
			component: MapGuide,
			meta: {
				title: '导览地图'
			}
		},
		{
			path: '/Evaluate',
			name: 'Evaluate',
			component: Evaluate,
			meta: {
				title: '讲解评价'
			}
		},
		{
			path: '/EvaluateDetails',
			name: 'EvaluateDetails',
			component: EvaluateDetails,
			meta: {
				title: '讲解评价'
			}
		}
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js